/**
 * window.Drupal.t polyfill
 * @param str
 */
if (!window.Drupal) {
  window.Drupal = {
    t: (str) => str,
  };
}

export default {
  apf: {
    filters: {
      apfLanguages: window.Drupal.t('Langues parlées'),
      apfDisabilityTypes: window.Drupal.t('Types de handicap'),
    },
    validation: {
      ruleA45: window.Drupal.t('La largeur de la porte doit être exprimée en cm.'),
    },
    error: {
      title: window.Drupal.t('APF TR: Questionnaire APF - erreur'),
      subtitle: window.Drupal.t('APF TR: Une erreur est survenue'),
      text: window.Drupal.t('APF TR: Veuillez réessayer ultérieurement'),
      btn_label: window.Drupal.t('APF TR: Réessayer'),
    },
    feedback: {
      mandatory: window.Drupal.t('Les champs marqués d\'un <span class="mandatory">*</span> sont obligatoires'),
      thanking: window.Drupal.t('APF TR: Merci de nous aider à améliorer Santé.fr.<br>Nous allons prendre en compte votre retour.'),
    },
    survey: {
      title_h1: window.Drupal.t('APF TR: Questionnaire APF'),
      prev: window.Drupal.t('APF TR: Revenir à la question précédente'),
      next: window.Drupal.t('APF TR: Passer à la question suivante'),
      save: window.Drupal.t('APF TR: Enregistrer'),
      save_and_next: window.Drupal.t('APF TR: Enregistrer et passer à la question suivante'),
      publish: window.Drupal.t('APF TR: Publier'),
      save_and_publish: window.Drupal.t('APF TR: Enregistrer et publier'),
      reset_field: window.Drupal.t('APF TR: Réinitialiser la valeur'),
      feedback: window.Drupal.t('APF TR: J\'ai un problème avec cette question'),
      handicap: window.Drupal.t('APF TR: Handicaps concernés :'),
      placeholder_select: window.Drupal.t('APF TR: Votre choix'),
    },
    attestation: {
      title_h1: window.Drupal.t('APF TR: Attestation APF'),
      title_h2: window.Drupal.t('APF TR: Annuaire des lieux de soins accessibles'),
      title_h3: window.Drupal.t('APF TR: Attestation de renseignement de l’annuaire'),
      datePublication_text: window.Drupal.t('APF TR: Document édité le'),
      question_non_repondu_text: window.Drupal.t('APF TR: Question non renseignée'),
      button_text_print: window.Drupal.t('APF TR: imprimer en format pdf'),
    },
    recap: {
      title: window.Drupal.t('APF TR: Dernière étape avant publication de vos informations'),
      title_mail: window.Drupal.t('APF TR: Saississez votre email et cliquez sur le bouton publier pour que les informations...'),
      title_recap_info: window.Drupal.t('APF TR: Récapitulatif des informations renseignées etc'),
      edit: window.Drupal.t('APF TR: Modifier'),
      submit: window.Drupal.t('APF TR: Répondre'),
      publish: window.Drupal.t('APF TR: Publier'),
      publish_confirm: window.Drupal.t('APF TR: Confirmer la publication'),
      unpublish: window.Drupal.t('APF TR: Dépublier'),
      unpublish_text: window.Drupal.t('APF TR: Vous souhaitez que vos données n\'apparaissent plus sur Santé.fr et ne soient plus diffusées en open data ? Cliquez sur etc'),
      mail_label: window.Drupal.t('APF TR: Merci de préciser votre email avant de publier vos réponses'),
      mail_hint: window.Drupal.t('APF TR: Entrez votre mail de contact ...'),
      consent_label: window.Drupal.t('APF TR: Phrase sur le consentement traductible'),
      consent_required: window.Drupal.t('APF TR: Votre consentement est requis'),
      mail_required: window.Drupal.t('APF TR: Une adresse e-mail est requis'),
      mail_valid: window.Drupal.t('APF TR: Veuillez entrer une adresse e-mail valide'),
      response_not_defined: window.Drupal.t('APF TR: Question non renseignée'),
    },
    pages: {
      title: window.Drupal.t('Accessibilité'),
      select_msg: window.Drupal.t('APF TR: Sélectionnez un ou plusieurs handicaps pour afficher les informations d\'accessibilité associées'),
      no_result: window.Drupal.t('APF TR: Aucune information relative à ce(s) handicap(s)'),
      legend: window.Drupal.t('APF TR: Sélectionnez un ou plusieurs handicaps pour afficher les informations d\'accessibilité associées'),
    },
  },
};
